import './style.css';
import Experience from './Experience/Experience.js';

function setupExperienceLoader(experience) {
  const loader = document.getElementById('experience-loader');
  const bar = document.getElementById('loader-bar');
  const percent = document.getElementById('loader-percent');
  if (!loader || !experience?.resources) return;

  const setProgress = (value) => {
    const clamped = Math.max(0, Math.min(100, Math.round(value)));
    if (bar) bar.style.width = `${clamped}%`;
    if (percent) percent.textContent = `${clamped}%`;
  };

  const hideLoader = () => {
    setProgress(100);
    loader.classList.add('is-done');
    loader.setAttribute('aria-busy', 'false');
    document.body.classList.remove('is-loading');
    window.setTimeout(() => {
      loader.remove();
    }, 600);
  };

  const { resources } = experience;
  const alreadyDone =
    resources.groups.assets.length === 0 && resources.groups.loaded.length > 0;

  if (alreadyDone) {
    hideLoader();
    return;
  }

  resources.on('progress', (group) => {
    if (!group?.toLoad) return;
    setProgress((group.loaded / group.toLoad) * 100);
  });

  resources.on('end', () => {
    // Let the first painted frame of the room land before fading out
    requestAnimationFrame(() => {
      requestAnimationFrame(hideLoader);
    });
  });
}

// Initialize Experience (only on pages that have the canvas element)
const experienceTarget = document.querySelector('.experience');
if (experienceTarget) {
  window.experience = new Experience({ targetElement: experienceTarget });
  setupExperienceLoader(window.experience);
}

// Initialize language switcher
class App {
  constructor() {
    this.init();
  }
  
  init() {
    this.setupLanguageSwitcher();
  }
  
  setupLanguageSwitcher() {
    const langButtons = document.querySelectorAll('.lang-btn');
    
    langButtons.forEach(btn => {
      btn.addEventListener('click', () => {
        const lang = btn.dataset.lang;
        
        if (lang === 'en') {
          // Switch to English - redirect to contact.berkantaslan.com
          window.location.href = 'https://contact.berkantaslan.com';
        } else {
          // Switch to Turkish - redirect to iletisim.berkantaslan.com
          window.location.href = 'https://iletisim.berkantaslan.com';
        }
      });
    });
  }
}

// Initialize app when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new App();
});